
<div class="fv-row" [formGroup]="TaratanTypeform" dir="rtl">
  <div class="row">
    <div class="col-lg-6" dir="rtl" *ngFor="let siblings of siblings">

      <!-- {{siblings}} -->

      <input formControlName="court_id" name="court_id" type="radio" class="btn-check"
        id="{{siblings['id']}}" [value]="siblings['id']" />
      <label dir="rtl" class="
          btn btn-outline btn-outline-dashed btn-outline-default
          p-7
          d-flex
          align-items-center
          mb-10" for="{{siblings['id']}}">
        <span class="d-block fw-bold text-start">
          <span class="text-dark fw-bolder d-block fs-4 mb-2">
            {{siblings['code']}}
          </span>
          <!-- <span class="text-gray-400 fw-bold fs-6">
           {{ siblings['id']}}
          </span> -->
        </span>
        <span class="svg-icon svg-icon-3x me-5">
        
        </span>
      </label>
    </div>

  </div>
</div>
